/**
 * @generated SignedSource<<22f82fff5bd1a0a13e09bdbf08d372a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ComplexMenuDesktopVerticalSubmenu_navigationItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NavigationItem",
      "kind": "LinkedField",
      "name": "children",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ComplexMenuDesktopVerticalSubmenuItem_navigationItem"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NavigationItem",
  "abstractKey": null
};

node.hash = "d4e77fd3e72331387fbca81614ea5a9d";

module.exports = node;
